import script from "./QScrollUpButton.vue?vue&type=script&setup=true&lang=js"
export * from "./QScrollUpButton.vue?vue&type=script&setup=true&lang=js"

import "./QScrollUpButton.vue?vue&type=style&index=0&id=66ba0e1e&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66ba0e1e"]])

export default __exports__